import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthHeader from '../../components/ui/AuthHeader';
import OnboardingProgress from '../../components/ui/OnboardingProgress';
import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import Icon from '../../components/AppIcon';

const SignupAndOnboarding = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);

  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailAddress: "",
    companyName: "",
    website: "",
    industry: "",
    businessType: "",
    annualRevenueRange: "",
    primaryBusinessGoal: "",
    problemSolved: "",
    biggestChallenge: "",
    keyPartners: "",
    valueProposition: "",
    customerRelationships: "",
    customerSegments: "",
    keyActivities: "",
    channels: "",
    keyResources: "",
    costStructure: "",
    revenueStreams: "",
    financialFile: null,
  });

  const steps = [
    { id: 1, label: 'Basic Information', icon: 'User' },
    { id: 2, label: 'Business Context', icon: 'Briefcase' }
  ];

  const handleUpdateFormData = (updates) => {
    setFormData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const handleStepClick = (stepId) => {
    if (stepId <= currentStep) {
      setCurrentStep(stepId);
    }
  };

  const handleNextStep = () => {
    setCurrentStep(2);
  };

  const handlePreviousStep = () => {
    setCurrentStep(1);
  };

  const handleCompleteSetup = (data) => {
  console.log("Final data:", data);
  navigate("/business-model-canvas");
};


  return (
    <div className="min-h-screen bg-background">
      <AuthHeader isAuthenticated={false} />

      <main className="pt-24 pb-12 px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/10 mb-4">
              <Icon name="Rocket" size={32} color="var(--color-primary)" />
            </div>

            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-3">
              Welcome to Business Jadhak
            </h1>

            <p className="text-base md:text-lg text-muted-foreground font-body max-w-2xl mx-auto">
              Let's set up your account and understand your business better to provide personalized insights
            </p>
          </div>

          <OnboardingProgress
            currentStep={currentStep}
            totalSteps={2}
            steps={steps}
            onStepClick={handleStepClick}
          />

          <div className="bg-card rounded-xl elevation-lg p-6 md:p-8 lg:p-10 mt-8">
            <div className="mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2">
                {currentStep === 1 ? 'Basic Information' : 'Business Context'}
              </h2>

              <p className="text-sm md:text-base text-muted-foreground font-body">
                {currentStep === 1
                  ? 'Tell us about yourself and your business to get started'
                  : 'Help us understand your business challenges and goals'}
              </p>
            </div>

            {currentStep === 1 && (
              <StepOne
                formData={formData}
                onUpdate={handleUpdateFormData}
                onNext={handleNextStep}
              />
            )}

            {currentStep === 2 && (
              <StepTwo
                formData={formData}
                onUpdate={handleUpdateFormData}
                onBack={handlePreviousStep}
                onComplete={handleCompleteSetup}
              />
            )}
          </div>

          <div className="mt-8 p-4 md:p-6 bg-accent/10 border border-accent/20 rounded-lg">
            <div className="flex items-start gap-3">
              <Icon
                name="Shield"
                size={24}
                color="var(--color-accent)"
                className="flex-shrink-0 mt-1"
              />

              <div>
                <h3 className="text-sm md:text-base font-medium text-foreground font-body mb-1">
                  Your Data is Secure
                </h3>

                <p className="text-xs md:text-sm text-muted-foreground font-body">
                  We use industry-standard encryption to protect your business information.
                  Your data is never shared with third parties without your explicit consent.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SignupAndOnboarding;